module.exports = new Promise((resolve) => {
    const script = document.createElement('script');
    let settled = false;
    const fail = (message) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      console.warn(message);
      resolve({
        get: () => Promise.reject(new Error(message)),
        init: () => undefined
      });
    };
    script.src = 'https://app.bellwetherit.com/assets/client-profitability/remoteEntry.js';
    script.onload = () => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      script.onload = null;
      script.onerror = null;
      script.remove();
      resolve({
        get: (request) => window['clientProfitability']
          ? window['clientProfitability'].get(request)
          : Promise.reject(new Error('Module clientProfitability not available')),
        init: (shareScope) => {
          try {
            return window['clientProfitability'] ? window['clientProfitability'].init(shareScope) : undefined;
          } catch (error) {
            console.warn('clientProfitability init failed:', error);
            return undefined;
          }
        }
      });
    };
    script.onerror = () => fail('Failed to load remote: clientProfitability');
    const deadline = setTimeout(() => fail('Timed out loading remote: clientProfitability'), 10000);
    document.head.appendChild(script);
  });